import { render, staticRenderFns } from "./CaseTypeTab.vue?vue&type=template&id=64ba4c6a"
import script from "./CaseTypeTab.vue?vue&type=script&lang=js"
export * from "./CaseTypeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports